// Message groups (#656): a run of messages from one person shows one header (picture, name, time). A message starts a new
// group, with its own header, after a quiet gap, so a message sent hours later does not hide under an old time. One rule for
// every client; the cases are shared/cases/message-groups.json, which the Swift and Kotlin ports run too; the web imports
// this file. The Bubbles display's centred time line is a different rule with its own gap (`STAMP_MS`, bubbleStamp.ts).

/** A message starts a new group when more than this long has passed since the one above it: 7 minutes. */
export const GROUP_MS = 7 * 60_000;

/** What the rule reads. Times are ms since 1970. */
export interface GroupInput {
  /** The sent time of the message just above, whatever it is; null for the first one held. */
  prevTs: number | null;
  /** The message's own sent time. */
  ts: number;
  /** The message above is from the same person. */
  sameAuthor: boolean;
  /** The message above was sent the same way: both by the person, or both by their AI ("via"). */
  sameVia: boolean;
  /** A day line goes above the message. */
  newDay: boolean;
  /** The message quotes another (a reply). */
  reply: boolean;
  /** The "New" line goes above the message. */
  newLine: boolean;
  /**
   * Anything else a client sets a message apart for: its own list of reasons for what is above or in the message
   * (a card, a quiet system line, a failed send, a forward). Each client keeps its own list.
   */
  apart: boolean;
}

/**
 * Whether the message starts a new group. True for the first message held, a new person, a different "via", a day line,
 * a reply, the "New" line, a client's own reason (`apart`), and when more than `GROUP_MS` has passed: exactly 7 minutes is
 * still one group. A message that sorts before the one above it (a clock that ran back) is not a gap.
 */
export function startsGroup(i: GroupInput): boolean {
  if (i.prevTs === null) return true;
  return !i.sameAuthor || !i.sameVia || i.newDay || i.reply || i.newLine || i.apart || i.ts - i.prevTs > GROUP_MS;
}
